module.exports = __webpack_public_path__ + "img/muhammadsharif-sufizoda.38b27864.jpg";